import { Outlet, useNavigate } from 'react-router-dom';
import { Header } from './Header';
import { SidebarNav } from './SidebarNav';
import { useIdleLogout } from '@/hooks/useIdleLogout';
import { logout as logoutRequest } from '@/services/auth';
import { useAuthStore } from '@/store/authStore';
import type { CurrentUser } from '@/types';

/** Utilisateur de repli (sécurité : ne s'affiche jamais en pratique, route protégée). */
const FALLBACK_USER: CurrentUser = {
  id: '—',
  nom: '',
  prenom: 'Utilisateur',
  email: '',
  role: 'LECTURE',
};

/**
 * Ossature de l'application : sidebar fixe + header sticky + zone de contenu
 * scrollable rendue via <Outlet />. Gère la déconnexion et l'auto-logout.
 */
export function AppLayout() {
  const navigate = useNavigate();
  const user = useAuthStore((s) => s.user);
  const clearSession = useAuthStore((s) => s.clearSession);
  useIdleLogout(8);

  const handleLogout = async () => {
    await logoutRequest();
    clearSession();
    navigate('/login', { replace: true });
  };

  return (
    <div className="flex h-screen overflow-hidden bg-surface-primary print:block print:h-auto print:overflow-visible">
      <SidebarNav user={user ?? FALLBACK_USER} onLogout={handleLogout} />
      <div className="flex min-w-0 flex-1 flex-col print:block">
        <Header />
        <main className="scrollbar-thin flex-1 overflow-y-auto print:overflow-visible">
          <div className="mx-auto w-full max-w-[1400px] px-5 py-6 lg:px-8 print:max-w-none print:p-0">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
